import { Radio, RadioList, Text } from "@ucl/react-library";
import { Trans, useTranslation } from "react-i18next";
import { SelectTile } from "../select-tile/select-tile";
import { translationMapping } from "src/utils/translation-mappings";
import { useFormContext } from "react-hook-form";
import { useBoundInput } from "src/hooks/use-bound-input";

export enum ReceivedLetterOptions {
  Received="received",
  NotReceived="not-received"
}

export const ReceivedLetter = ({ showComplaint = false }: { showComplaint?: boolean; }) => {
  const { t } = useTranslation("translation", { keyPrefix: "receivedLetter" });
  const { t: genericT } = useTranslation();

  const { control } = useFormContext();
  const receivedLetterProps = useBoundInput({ name: "receivedLetter", control });

  const infoParas = showComplaint ? t("complaintInfoParas", { returnObjects: true }) : t("infoParas", { returnObjects: true });

  return (
    <div className="flex flex-col gap-10" data-testid="receivedLetter">
      <div className="flex flex-col gap-5">
        {showComplaint ? (
          <div>
            <Text renderAs="h3" styleType="h4" fontWeight="semi-bold">
              {t("complaintTitle")}
            </Text>
          </div>
        ) : (
          <Text renderAs="h2" styleType="h4" fontWeight="semi-bold">
            {t("title")}
          </Text>
        )}
        <RadioList variant="tile" size="large" {...receivedLetterProps}>
          <Radio
            label={t("receivedRadio")}
            value={ReceivedLetterOptions.Received}
            className="flex flex-col-reverse !items-start"
            data-testid="receivedRadio"
          >
            <SelectTile
              title={t("receivedTitle")}
              description={showComplaint ? [t("receivedComplaintSubtitle")] : [t("receivedSubtitle")]}
            />
          </Radio>
          <Radio
            label={t("notReceivedRadio")}
            value={ReceivedLetterOptions.NotReceived}
            className="flex flex-col-reverse !items-start"
            data-testid="notReceivedRadio"
          >
            <SelectTile title={showComplaint ? t("notReceivedComplaintTitle") : t("notReceivedTitle")} />
          </Radio>
        </RadioList>
      </div>
      {receivedLetterProps.value === ReceivedLetterOptions.NotReceived && (
        <div className="flex flex-col gap-5">
          <Text renderAs="h3" styleType="h4" fontWeight="semi-bold">
            {showComplaint ? t("complaintInfoTitle") : t("infoTitle")}
          </Text>
          <div className="flex flex-col gap-3">
            {Array.isArray(infoParas) &&
              infoParas.map((para) => (
                <Text.P size="large" key={para}>
                  <Trans i18nKey={para} components={translationMapping(genericT)} />
                </Text.P>
              ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ReceivedLetter;
